import {
  LINK,
  BOLD_ITALIC_STAR,
  BOLD_STAR,
  ITALIC_STAR,
  $convertFromMarkdownString,
} from "@lexical/markdown";
import { LinkNode } from "@lexical/link";
import { TextNode } from "lexical";

export const MARKDOWN_TRANSFORMERS = [
  LINK,
  BOLD_ITALIC_STAR,
  BOLD_STAR,
  ITALIC_STAR,
];

export const THEME = {
  text: {
    bold: "text-medium",
    italic: "italic",
  },
  link: "text-blue-primary underline-offset-4 hover:underline",
};

export const BASE_CONFIG = {
  namespace: "bulkMessage",
  theme: THEME,
  onError: (error: Error) => console.error(error),
  nodes: [LinkNode, TextNode],
};

export function buildEditorConfig({
  text,
  editable = true,
}: {
  text: string;
  editable?: boolean;
}) {
  return Object.assign(BASE_CONFIG, {
    editable,
    editorState: () =>
      $convertFromMarkdownString(text ?? "", MARKDOWN_TRANSFORMERS),
  });
}
